import i18n from 'i18n/config';

export const UPLOAD_STATUSES = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  DONE: 'uploaded',
  ERROR: 'error'
};

export const getUploadStatusesReadable = () => ({
  [UPLOAD_STATUSES.PENDING]: i18n.t('uploadStatuses.pending'),
  [UPLOAD_STATUSES.UPLOADING]: i18n.t('uploadStatuses.uploading'),
  [UPLOAD_STATUSES.DONE]: i18n.t('uploadStatuses.done'),
  [UPLOAD_STATUSES.ERROR]: i18n.t('uploadStatuses.error')
});

export const UPLOAD_TYPE = {
  FILE: 'file',
  VIDEO: 'video'
};
